import React from "react";
import { Link } from "react-router-dom";
import TableV2 from "src/components/ui/TableV2";

type LowStockRow = {
  _id?: string;
  productId?: string;
  name: string;
  stock: number;
  minStock: number;
};

interface LowStockTableProps {
  rows: LowStockRow[];
  canReorder?: boolean;
}

const LowStockTable: React.FC<LowStockTableProps> = ({
  rows,
  canReorder = false,
}) => {
  const columns = [
    {
      key: "productId",
      header: "Product ID",
      accessor: ({ row }: { row: LowStockRow }) => (
        <span className="text-gray-600">{row.productId || "-"}</span>
      ),
    },
    {
      key: "name",
      header: "Product",
      accessor: ({ row }: { row: LowStockRow }) => (
        <span className="font-medium text-gray-900">{row.name}</span>
      ),
    },
    { key: "stock", header: "Current Stock" },
    { key: "minStock", header: "Reorder Level" },
    {
      key: "action",
      header: "Action",
      accessor: () =>
        canReorder ? (
          <Link
            to="/app/purchase/list"
            className="rounded-md border border-primary-200 px-3 py-1 text-xs font-semibold text-primary-600 hover:border-primary-300"
          >
            Reorder
          </Link>
        ) : (
          <span className="text-xs text-gray-400">-</span>
        ),
    },
  ];

  return (
    <div className="mt-4">
      <TableV2 columns={columns} data={rows} />
    </div>
  );
};

export default LowStockTable;
